module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"live":"Live","first_episode":"Episode 1"},"fr":{"live":"Direct","first_episode":"Épisode 1"}}')
  delete Component.options._Ctor
}
